import { render, staticRenderFns } from "./ConfirmRemoveAllAiAttractions.vue?vue&type=template&id=58821815&scoped=true"
import script from "./ConfirmRemoveAllAiAttractions.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveAllAiAttractions.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRemoveAllAiAttractions.vue?vue&type=style&index=0&id=58821815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58821815",
  null
  
)

export default component.exports